import { render, staticRenderFns } from "./BoardItemCard.vue?vue&type=template&id=47632628&"
import script from "./BoardItemCard.vue?vue&type=script&lang=js&"
export * from "./BoardItemCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardItemCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports